// Import React
import React from 'react';

// Import dependencies
import { render } from 'react-dom';
import { Provider } from 'mobx-react';
import { RouterStore, syncHistoryWithStore } from 'mobx-react-router'
import { Router, Route, IndexRoute, hashHistory } from 'react-router';
// import { createHistory, useBasename } from 'history';

// Import components
import App from './app/components/App'
import AppLoggedOut from './app/components/AppLoggedOut'
import NotFound from './app/components/NotFound'
import CloseWindow from './app/components/CloseWindow'
import Unauthorized from './app/components/Unauthorized'
import Dashboard from './app/components/Dashboard/Dashboard';
import ExamDashboard from './app/components/ExamDashboard/ExamDashboard';
import LocateProctor from './app/components/LocateProctor/LocateProctor';
import ExamType from './app/components/ExamEdit/ExamType';
import ExamEdit from './app/components/ExamEdit/ExamEdit';
import ExamAttachments from './app/components/ExamEdit/ExamAttachments';
import Enroll from './app/components/Enroll/Enroll';
import EnrollMobile from './app/components/Enroll/EnrollMobile';
import Transactions from './app/components/Account/Transactions';
import InstitutionTransactions from './app/components/Account/InstitutionTransactions';
import FundingRules from './app/components/FundingRules/FundingRules';
import Messages from './app/components/Messages/Inbox';
import Reports from './app/components/Reports/Reports';
import Downloads from './app/components/Reports/Downloads';
import Roster from './app/components/Roster/Roster';
import Users from './app/components/Roster/Users';
import Admins from './app/components/Admins/Admins';
import CourseOfferings from './app/components/CourseOfferings/CourseOfferings';
import Settings from './app/components/Settings/Settings';
import Integrations from './app/components/Integrations/Integrations';
import ChooseProctorType from './app/components/StudentDashboard/ChooseProctorType';
import Vouchers from './app/components/Vouchers/Vouchers';
import AddVoucher from './app/components/Vouchers/AddVoucher';
import SelfManagedAccounts from './app/components/SelfManagedAccounts/SelfManagedAccounts';
import SupportTickets from './app/components/SupportTickets/SupportTickets';
import Session from './app/components/Account/Session';
import ExamApprovals from './app/components/Approvals/ExamApprovals';
import SessionExpired from './app/components/SessionExpired';
import Maintenance from './app/components/Maintenance';
import SignOut from './app/components/SignOut';
import SignedOut from './app/components/SignedOut';
import SessionStart from './app/components/SessionStart/SessionStart';
// import InstructorAppointments from './app/components/CourseDashboard/InstructorAppointments';
import StartVTC from './app/components/StudentDashboard/StartVTC';
import ChooseExam from './app/components/StudentDashboard/ChooseExam.js';
import BlackoutDates from './app/components/BlackoutDates/BlackoutDates';
import VTCNotice from './app/components/VTCNotice'
import SessionEndAutomated from './app/components/SessionEnd/SessionEndAutomated';
import ProvisionExam from './app/components/provision/ProvisionExam';

// External Components
import AppOutside from './app/components/AppOutside'
import AppOutsideOnboard from './app/components/AppOutsideOnboard'
import SessionManager from './app/components/Outside/SessionManager';
import TimeZone from './app/components/Outside/TimeZone';
// import SessionDetails from './app/components/Outside/SessionDetails';

// Import stores
export const routingStore = new RouterStore();
import store from './app/stores/';

const stores = {routing: routingStore, store}

const history = syncHistoryWithStore(hashHistory, routingStore);

// Add the user agent as an attribute on the document
const ua = navigator.userAgent;
document.querySelector('html').setAttribute('data-ua', ua);

// Flag Firefox
if(ua.indexOf('Firefox') > -1) {
  document.querySelector('html').className += ' firefox'
}

// Flag Safari
if(ua.indexOf('Safari') > -1 && ua.indexOf('Chrome') < 0) {
  document.querySelector('html').className += ' safari'
}

// Flag IE 10
if(ua.indexOf('MSIE 10.0') > -1) {
  document.querySelector('html').className += ' ie-true lt-ie11'
}

// Flag IE 11
if(!!window.MSInputMethodContext && !!document.documentMode) {
  document.querySelector('html').className += ' ie-true'
}

// Flag Edge
if(ua.indexOf('Edge') > -1) {
  document.querySelector('html').className += ' ie-true'
}

// Flag Puffin
if(ua.indexOf('Puffin') > -1) {
  document.querySelector('html').className += ' puffin'
}

// Aids with button focus styles
document.querySelector('body').addEventListener('click', function(e){
  if(e.target.className && typeof e.target.className === 'string') {
    if(
        e.target.className.indexOf('btn') > -1 ||
        e.target.className.indexOf('calendar__nav') > -1
    ) {
      e.target.className += ' btn-clicked';

      e.target.addEventListener('blur', function(e){
        e.target.className = e.target.className.replace('btn-clicked', '');
      })
    }
  }
});

// Detect touch devices
if('ontouchstart' in document.documentElement) {
  document.querySelector('html').className += ' touch';
}

// Track pageviews
let gaTimeout = null;

history.listen(location => {
  // Track on route change
  if(window.ga) {
    trackPageview(location.pathname + location.search);
  }
});

// Track on initial load
trackPageview(history.getCurrentLocation().pathname + history.getCurrentLocation().search);

function sanitizeUrl(url) {
  // Make sure there’s a leading slash
  if(url.charAt(0) !== '/') {
    url = `/${url}`;
  }

  // Replace sid segments with placeholders
  if(url.indexOf('/course/CU') > -1) {
    // Course sid
    url = url.replace(/(\/course\/)\w+/, '$1{courseSid}');
  }

  if(url.indexOf('/exam/EX') > -1) {
    // Exam sid
    url = url.replace(/(\/exam\/)\w+/, '$1{examSid}');
  }

  if(url.indexOf('/exams/EX') > -1) {
    // Exam sid
    url = url.replace(/(\/exams\/)\w+/, '$1{examSid}');
  }

  if(url.indexOf('/edit/EX') > -1) {
    // Edit exam sid
    url = url.replace(/(\/edit\/)\w+/, '$1{examSid}');
  }

  if(url.indexOf('/session/ES') > -1) {
    // Session sid
    url = url.replace(/(\/session\/)\w+/, '$1{sessionSid}');
  }

  if(url.indexOf('session=ES') > -1) {
    // Enrollment sid param
    url = url.replace(/(session=)\w+/, '$1{sessionSid}');
  }

  if(url.indexOf('/configuration/EC') > -1) {
    // Configuration sid
    url = url.replace(/(\/configuration\/)\w+/, '$1{configurationSid}');
  }

  if(url.indexOf('accommodation=EC') > -1) {
    // Configuration sid param
    url = url.replace(/(accommodation=)\w+/, '$1{configurationSid}');
  }

  if(url.indexOf('/accommodation/EN') > -1) {
    // Enrollment sid
    url = url.replace(/(\/accommodation\/)\w+/, '$1{enrollmentSid}');
  }

  if(url.indexOf('enrollment=EN') > -1) {
    // Enrollment sid param
    url = url.replace(/(enrollment=)\w+/, '$1{enrollmentSid}');
  }

  if(url.indexOf('/group/PG') > -1) {
    // Proctor group sid
    url = url.replace(/(\/group\/)\w+/, '$1{group}');
  }

  if(url.indexOf('/view/MT') > -1) {
    // View message thread sid
    url = url.replace(/(\/view\/)\w+/, '$1{messageThreadSid}');
  }

  if(url.indexOf('/view/US') > -1) {
    // View user sid
    url = url.replace(/(\/view\/)\w+/, '$1{userSid}');
  }

  if(url.indexOf('/view/ST') > -1) {
    // View support ticket sid
    url = url.replace(/(\/view\/)\w+/, '$1{supportTicketSid}');
  }

  if(url.indexOf('/edit/US') > -1) {
    // Edit user sid
    url = url.replace(/(\/edit\/)\w+/, '$1{userSid}');
  }

  if(url.indexOf('/edit/CO') > -1) {
    // Edit course offering sid
    url = url.replace(/(\/edit\/)\w+/, '$1{offeringSid}');
  }

  if(url.indexOf('/edit/PA') > -1) {
    // Edit proctor account sid
    url = url.replace(/(\/edit\/)\w+/, '$1{proctorAccountSid}');
  }

  if(url.indexOf('/edit/FR') > -1) {
    // Edit funding rule sid
    url = url.replace(/(\/edit\/)\w+/, '$1{fundingRuleSid}');
  }

  if(url.indexOf('/edit/VO') > -1) {
    // Edit voucher sid
    url = url.replace(/(\/edit\/)\w+/, '$1{voucherSid}');
  }

  if(url.indexOf('/edit/BD') > -1) {
    // Edit blackout date sid
    url = url.replace(/(\/edit\/)\w+/, '$1{blackoutDateSid}');
  }

  return url;
}

function trackPageview(url) {
  if(url.indexOf('?token=') > -1) {
    url = '/';
  }

  // Wait until ga function is available
  const gaDelay = setInterval(function(){
    if(window.ga) {
      clearInterval(gaDelay);

      // Make sure we don't send the event multiple times
      gaTimeout = setTimeout(function(){
        clearTimeout(gaTimeout);
        const cleanUrl = sanitizeUrl(url);
        window.ga('send', 'pageview', cleanUrl);
      }, 500);
    }
  }, 100);
}

        



// Routes
const router = (
  <Provider {...stores}>
    <Router history={history} {...stores}>
      <Route
        path="account"
        component={AppLoggedOut}
      >
        <Route path="sign-in" component={(props) => <Session {...stores} content="SignIn" />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="enroll"
        component={App}
        feature="onboarding"
      >
        <IndexRoute component={(props) => <Enroll {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="enroll-mobile"
        component={AppOutside}
      >
        <IndexRoute component={(props) => <EnrollMobile {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="proctor-search"
        component={App}
        feature="proctorSearch"
      >
        <IndexRoute component={(props) => <LocateProctor {...stores} />} />
      </Route>
      <Route
        path="schedule-automated"
        component={App}
        feature="schedule"
      >
        <Route
          path="exam/:examId/session/:sessionId/configuration/:configurationId"
          component={(props) => <ChooseProctorType {...stores} automatedOnly />}
        />
        <Route
          path="exam/:examId/session/:sessionId/configuration/:configurationId/scheduleClosed"
          component={(props) => <ChooseProctorType {...stores} automatedOnly={true} scheduleClosed={true} />}
        />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="schedule-session"
        component={App}
        feature="schedule"
      >
        <Route path="exam/:examId/session/:sessionId" component={(props) => <ChooseProctorType {...stores} />} />
        <Route path="exam/:examId/session/:sessionId/configuration/:configurationId" component={(props) => <ChooseProctorType {...stores} />} />
        <Route path="exam/:examId/session/:sessionId/configuration/:configurationId/search" component={(props) => <LocateProctor {...stores} />} />
        <Route path="exam/:examId/session/:sessionId/configuration/:configurationId/search/group/:groupId" component={(props) => <LocateProctor {...stores} />} />
        <Route path="group/:groupId" component={(props) => <ChooseExam {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="reschedule-session"
        component={App}
        feature="reschedule"
      >
        <Route path="exam/:examId/session/:sessionId" component={(props) => <ChooseProctorType reschedule={true} {...stores} />} />
        <Route path=":examId/search" component={(props) => <LocateProctor {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="exams"
        component={App}
        feature="exams"
      >
        <Route path="type" component={(props) => <ExamType {...stores} />} />
        <Route path="add" component={(props) => <ExamEdit {...stores} />} />
        <Route path=":examId" component={(props) => <ExamDashboard {...stores} />} />
        <Route path="edit/:examId" component={(props) => <ExamEdit {...stores} />} />
        <Route path=":examId/attachments" component={(props) => <ExamAttachments {...stores} />} />
        <Route path=":examId/accommodation" component={(props) => <ExamDashboard {...stores} />} />
        <Route path=":examId/accommodation/:enrollmentId" component={(props) => <ExamDashboard {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="funding-rules"
        component={App}
        feature="fundingRules"
      >
        <IndexRoute component={(props) => <FundingRules {...stores} />} />
        <Route path="add" component={(props) => <FundingRules {...stores} />} />
        <Route path="edit/:fundingRuleId" component={(props) => <FundingRules {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="messages"
        component={App}
        feature="messages"
      >
        <IndexRoute component={(props) => <Messages {...stores} />} />
        <Route path="view/:messageId" component={(props) => <Messages {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="reports"
        component={App}
        feature="reports"
      >
        <IndexRoute component={(props) => <Reports {...stores} />} />
        <Route path="downloads" component={(props) => <Downloads {...stores} />} />
        <Route path="*" component={(props) => <Reports {...stores} />} />
      </Route>
      <Route
        path="roster"
        component={App}
        feature="roster"
      >
        <IndexRoute component={(props) => <Roster {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="provision"
        component={AppOutside}
        feature="provisionExam"
      >
        <IndexRoute component={(props) => <ProvisionExam {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="admins"
        component={App}
        feature="admins"
      >
        <IndexRoute component={(props) => <Admins {...stores} />} />
        <Route path="edit/:userSid" component={(props) => <Admins {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="users"
        component={App}
        feature="users"
      >
        <IndexRoute component={(props) => <Users installation={true} {...stores} />} />
        <Route path="view/:userSid" component={(props) => <Users installation={true} {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="course-offerings"
        component={App}
        feature="courseOfferings"
      >
        <IndexRoute component={(props) => <CourseOfferings {...stores} />} />
        <Route path="edit/:offeringSid" component={(props) => <CourseOfferings {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="self-managed-proctors"
        component={App}
        feature="selfManagedProctors"
      >
        <IndexRoute component={(props) => <SelfManagedAccounts {...stores} />} />
        <Route path="add" component={(props) => <SelfManagedAccounts {...stores} />} />
        <Route path="edit/:proctorId" component={(props) => <SelfManagedAccounts {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="settings"
        component={App}
        feature="settings"
      >
        <IndexRoute component={(props) => <Settings {...stores} content="User" />} />
        <Route path="institution" component={(props) => <Settings {...stores} content="Institution" />} />
        <Route path="institution/*" component={(props) => <Settings {...stores} content="Institution" />} />
        <Route path="proctor-groups" component={(props) => <Settings {...stores} content="ProctorGroups" />} />
        <Route path="*" component={(props) => <Settings {...stores} content="User" />} />
      </Route>
      <Route
        path="integrations"
        component={App}
        feature="integrations"
      >
        <IndexRoute component={(props) => <Integrations {...stores} />} />
      </Route>
      <Route
        path="support"
        component={App}
        feature="support"
      >
        <IndexRoute component={(props) => <SupportTickets {...stores} />} />
        <Route path="view/:ticketId" component={(props) => <SupportTickets {...stores} />} />
        <Route path="add" component={(props) => <SupportTickets {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="vouchers"
        component={App}
        feature="vouchers"
      >
        <IndexRoute component={(props) => <Vouchers {...stores} />} />
        <Route path="add" component={(props) => <AddVoucher {...stores} />} />
        <Route path="edit/:voucherId" component={(props) => <Vouchers {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="exam-approvals"
        component={App}
        feature="examApprovals"
      >
        <IndexRoute component={(props) => <ExamApprovals {...stores} />} />
        <Route path="review/exam/:examId/configuration/:approvalId/course/:courseId" component={(props) => <ExamApprovals {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="bvirtual-manager"
        component={AppOutside}
        feature="bVirtual"
      >
        <IndexRoute component={(props) => <SessionManager megameeting={true} multi={true} {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="session-details"
        component={AppOutside}
        feature="sessionManager"
      >
        <IndexRoute component={(props) => <SessionManager megameeting={false} multi={false} {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="blackout-dates"
        component={App}
        feature="blackoutDates"
      >
        <IndexRoute component={(props) => <BlackoutDates {...stores} />} />
        <Route path="add" component={(props) => <BlackoutDates {...stores} />} />
        <Route path="edit/:blackoutDateSid" component={(props) => <BlackoutDates {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="session-start"
        component={App}
        feature="sessionStart"
      >
        <IndexRoute component={(props) => <SessionStart {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="session-start-external"
        component={AppOutsideOnboard}
        feature="sessionStart"
      >
        <IndexRoute component={(props) => <SessionStart {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="session-expired"
        component={AppLoggedOut}
      >
        <IndexRoute component={(props) => <SessionExpired {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="maintenance"
        component={AppLoggedOut}
      >
        <IndexRoute component={(props) => <Maintenance {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="unauthorized"
        component={AppLoggedOut}
      >
        <IndexRoute component={(props) => <Unauthorized {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="sign-out"
        component={AppLoggedOut}
      >
        <IndexRoute component={(props) => <SignOut {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="signed-out"
        component={AppLoggedOut}
      >
        <IndexRoute component={(props) => <SignedOut {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="rb-complete"
        component={AppOutside}
      >
        <IndexRoute component={(props) => <CloseWindow {...stores} />} />
      </Route>
      <Route
        path="launch"
        component={AppOutside}
      >
        <IndexRoute component={(props) => <StartVTC {...stores} hideDashboard={true} />} />
        <Route path=":accessCode" component={(props) => <StartVTC {...stores} hideDashboard={true} />} />
      </Route>
      <Route
        path="locate-proctor"
        component={App}
        feature="locateProctor"
      >
        <IndexRoute component={(props) => <LocateProctor {...stores} />} />
      </Route>
      <Route
        path="transactions"
        component={App}
        feature="transactions"
      >
        <IndexRoute component={(props) => <Transactions {...stores} />} />
      </Route>
      <Route
        path="ledger"
        component={App}
        feature="ledger"
      >
        <IndexRoute component={(props) => <InstitutionTransactions {...stores} />} />
      </Route>
      <Route
        path="instructor-appointments"
        component={App}
        feature="instructorAppointments"
      >
        <IndexRoute component={(props) => <Reports {...stores} />} />
      </Route>
      <Route path="refresh" component={null} />
      <Route
        path="vtc"
        component={AppLoggedOut}
        feature="vtc"
      >
        <IndexRoute component={(props) => <VTCNotice {...stores} />} />
      </Route>
      <Route
        path="time-zone"
        component={AppOutside}
      >
        <IndexRoute component={(props) => <TimeZone {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="automated/end-session"
        component={AppLoggedOut}
      >
        <IndexRoute component={(props) => <SessionEndAutomated {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
      <Route
        path="/"
        component={App}
        feature="dashboard"
      >
        <IndexRoute component={(props) => <Dashboard {...stores} />} />
        <Route path="index.html" component={(props) => <Dashboard {...stores} />} />
        <Route path="*" component={(props) => <NotFound {...stores} />} />
      </Route>
    </Router>
  </Provider>
);

render(router , document.querySelector('#app'));



// WEBPACK FOOTER //
// ./src/index.js